// extracted by mini-css-extract-plugin
export default {"loadingWarp":"hz-components-hz-layout-sider-menu-index-loadingWarp","loading":"hz-components-hz-layout-sider-menu-index-loading"};